import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './Layout';
import NotFound from './NotFound';

export const souscriptionFactureRouter = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        lazy: () => import("./pages/SouscriptionPage").then(m => ({ Component: m.SouscriptionPage })),
      },
      {
        path: 'success',
        lazy: () => import("./pages/SuccessPage").then(m => ({ Component: m.SuccessPage })),
      },
      {
        path: '*',
        element: <NotFound />,
      }
    ]
  }
]);